<template>
    <v-layout v-if="Object.keys(user).length" row justify-center
              mt-5 mb-3
    >
        <v-flex class="xs12 text-xs-center">

            <v-layout v-for="certificate in user.available_certificates"
                      v-if="Object.keys(user.available_certificates).length" :key="coursePassingId" row
                      justify-center mt-3
            >
                <v-flex class="offset-xl4 xl8 offset-lg6 lg6 offset-md5 md7 offset-sm1 sm11 xs12 text-xs-left">
                    <a class="" @click.prevent="get_certificate_course(certificate.course_passing_id)"> {{ $t('Сертификат') }}
                        "{{ certificate.name }}"
                        <v-icon aria-hidden="true" translate="no">picture_as_pdf</v-icon>
                    </a>
                </v-flex>
            </v-layout>

        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name : 'UserCertificates',
  props: {
    user: {
      type   : Object,
      default: () => Object.create(null),
    },
  },
  computed: {
    ...mapGetters('course', ['certificate_url']),
  },
  methods: {
    async get_certificate_course(course_passing_id) {
      await this.get_certificate(course_passing_id);
      let win = window.open(this.certificate_url.url, '_blank');
      win.focus();
    },
    ...mapActions('course', ['get_certificate']),
  },
};
</script>

<style scoped>

</style>
